import { useScopedQuery } from "@/hooks/use-scoped-query";
import { GLOBAL_TENANT } from "@/queries/scope";
import { myWorkHoursQuery } from "@/queries/work-hours";
import { useStore } from "@/stores/store-context";
import type { TUserWorkHours } from "@/types/user";

/**
 * The signed-in user's own work hours (`app/queries/work-hours.ts`):
 * `undefined` until they load. `loadFailed` is a failed read with nothing to
 * show; the cache logs it.
 *
 * Must be called from an `observer` component.
 */
export function useMyWorkHours({ enabled = true }: { enabled?: boolean } = {}): {
  workHours: TUserWorkHours | undefined;
  loadFailed: boolean;
} {
  const { workHoursService } = useStore();
  const { query } = useScopedQuery(
    GLOBAL_TENANT,
    (scope) => myWorkHoursQuery(workHoursService, scope),
    { enabled, flag: null },
  );
  return { workHours: query.data, loadFailed: query.isError && query.data === undefined };
}
